// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3e3OO","title":"ClientCherryInfo_title__3my4f","itemText":"ClientCherryInfo_itemText__2FDOo"};